// migrated 1:1 from @nexato/nx-core-module, #688
import { Directive, HostListener, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SIDEBAR_CONTEXT } from '../services/sidebar/sidebar-context';
import { SidebarService } from '../services/sidebar/sidebar.service';

@Directive({
  selector: '[nxNewTabNavigation]'
})
export class NewTabNavigationDirective {
  @Input('nxNewTabNavigation') route: string | string[] = [];
  @Input() queryParams: { [key: string]: string } | undefined;

  // Sidebar context - true if this component is rendered inside a sidebar
  readonly isInSidebar = inject(SIDEBAR_CONTEXT, { optional: true }) ?? false;
  private readonly sidebarService = inject(SidebarService);

  constructor(private router: Router) {}

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    if (event.metaKey || event.ctrlKey) {
      event.preventDefault();
      // Create full URL for new tab
      const url = this.router.serializeUrl(
        this.router.createUrlTree(
          Array.isArray(this.route) ? this.route : [this.route]
        )
      );
      window.open(url, '_blank');
    } else if (this.isInSidebar) {
      // In sidebar: navigate to the route directly
      this.router.navigate(Array.isArray(this.route) ? this.route : [this.route]);
    } else {
      if (this.queryParams) {
        // Toggle-Logik: Wenn bereits ausgewählt → schließen
        const currentShowId = this.queryParams['show'];
        const isCurrentlySelected = this.sidebarService.selectedEntityId() === currentShowId;

        if (isCurrentlySelected) {
          // Schließen: Sidebar schließen und queryParams zurücksetzen
          this.sidebarService.close();
          this.router.navigate([], {
            queryParams: { type: null, show: null },
            queryParamsHandling: 'merge'
          });
        } else {
          // Öffnen: queryParams setzen (wie bisher)
          this.router.navigate([], {
            queryParams: this.queryParams,
            queryParamsHandling: 'merge'
          });
        }
      } else {
        this.router.navigate(Array.isArray(this.route) ? this.route : [this.route]);
      }
    }
  }
}
